<template>
	<div class="content-wrapper-scroll">
		<div class="content-wrapper">
			<div class="row gutters">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
							<div class="row">
								<div class="col-sm-3">
									<div class="field-wrapper">
										<div class="field-placeholder">Frequency *</div>
										<select
											class="form-control"
											v-model="meta.frequency_id"
											:class="{ 'is-invalid': errors.frequency_id }"
											@change="updateFromDateToDate"
											:disabled="frequencies.length === 0"
										>
											<option value="">
												{{ frequencies.length === 0 ? "Loading..." : "Select Frequency" }}
											</option>
											<option
												v-for="f in frequencies"
												:key="f.frequency_id"
												:value="f.frequency_id"
											>
												{{ f.frequency_name }}
											</option>
										</select>
										<span v-if="errors.frequency_id" class="invalid-feedback">{{
											errors.frequency_id[0]
										}}</span>
									</div>
								</div>

								<div class="col-sm-3">
									<div class="field-wrapper">
										<div class="field-placeholder">From Date *</div>
										<input
											class="form-control"
											v-model="meta.from_date"
											:class="{ 'is-invalid': errors.from_date }"
											type="date" disabled
										/>
										<span v-if="errors.from_date" class="invalid-feedback">{{
											errors.from_date[0]
										}}</span>
									</div>
								</div>

								<div class="col-sm-3">
									<div class="field-wrapper">
										<div class="field-placeholder">To Date *</div>
										<input
											class="form-control"
											v-model="meta.to_date"
											:class="{ 'is-invalid': errors.to_date }"
											type="date" disabled
										/>
										<span v-if="errors.to_date" class="invalid-feedback">{{
											errors.to_date[0]
										}}</span>
									</div>
								</div>

								<div class="col-sm-3 mt-2">
									<button
										type="button"
										class="btn btn-primary ms-1"
										@click="getHoFrequencyCompliance"
									>
										Generate
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Overall Compliance -->
			<div class="row gutters" v-if="ho_frequency_compliance != null">
				<div class="col-sm-12">
					<h5>Overall Compliance :: {{ frequency_name }} Checklist</h5>
					<div class="dashboard-header">
						<div class="dashboard-header-content" style="margin-left: -5px;">
							<div class="sales-tile-container">
								<div
									class="sales-tile"
									:style="{ background: getColor(ho_frequency_compliance) }"
									@click="showClusters = true"
								>
									<h4 id="label">
										{{ ho_frequency_compliance }}<span v-if="ho_frequency_compliance != 'NA'">%</span>
									</h4>
									<h6>{{ frequency_name }}</h6>
									<small>({{ overallSubmitted }}/{{ overallExpected }})</small>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Clusters -->
			<div class="row gutters mt-3" v-if="showClusters && clusters.length != 0">
				<div class="col-sm-12">
					<h5>Clusters : {{ frequency_name }}</h5>
					<div class="dashboard-header">
						<div class="dashboard-header-content" style="margin-left: -5px;">
							<div class="sales-tile-container">
								<template v-for="c in clusters" :key="c.cluster_id">
									<div
										class="sales-tile"
										:style="{ background: getColor(c.compliance) }"
										@click="selectCluster(c)"
									>
										<h4 id="label">
											{{ c.compliance }}<span v-if="c.compliance != 'NA'">%</span>
										</h4>
										<h6>{{ c.cluster_code }}</h6>
										<small>({{ c.submitted }}/{{ c.expected }})</small>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Plants -->
			<div class="row gutters mt-3" v-if="selectedCluster && selectedCluster.plants?.length">
				<div class="col-sm-12">
					<h5>Plants : {{ selectedCluster.cluster_code }} - {{ frequency_name }}</h5>
					<div class="dashboard-header">
						<div class="dashboard-header-content" style="margin-left: -5px;">
							<div class="sales-tile-container">
								<template v-for="p in selectedCluster.plants" :key="p.plant_id">
									<div
										class="sales-tile"
										:style="{ background: getColor(p.compliance) }"
										@click="getHoDepartmentCompliance(p.plant_id, p.plant_code)"
									>
										<h4 id="label">
											{{ p.compliance }}<span v-if="p.compliance != 'NA'">%</span>
										</h4>
										<h6>{{ p.plant_code }}</h6>
										<small>({{ p.submitted }}/{{ p.expected }})</small>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Departments -->
			<div class="row gutters mt-3" v-if="departments.length != 0">
				<div class="col-sm-12">
					<h5>Departments : {{ plant_code }}</h5>
					<div class="dashboard-header">
						<div class="dashboard-header-content" style="margin-left: -5px;">
							<div class="sales-tile-container">
								<template v-for="d in departments" :key="d.department_id">
									<div
										class="sales-tile"
										:style="{ background: getColor(d.compliance) }"
										@click="selectDepartment(d)"
									>
										<h4 id="label">{{ d.compliance }}%</h4>
										<h4 id="label" style="color: #ffd700 !important;">
											{{ d.deviated_components ?? 0 }}
										</h4>
										<h6>{{ d.department_name }}</h6>
										<small>({{ d.submitted }}/{{ d.expected }})</small>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Deviated Components - UPGRADED VERSION -->
			<div class="row gutters mt-3" v-if="deviated_components.length != 0">
				<div class="col-sm-12">
					<div class="d-flex justify-content-between">
						<h5>
							Deviated Components ({{ deviated.totalRows }}) : {{ plant_code }} : {{ department_name }}
						</h5>
						<button
							type="button"
							class="btn btn-warning"
							:disabled="selectedComponents.length === 0"
							data-bs-toggle="modal"
							data-bs-target="#multiRemarkModal"
							@click="openMultiRemarkModal"
						>
							Update Remarks
						</button>
					</div>

					<div class="card">
						<div class="card-body">
							<div class="table-responsive tabletop">
								<table class="table table-sm table-bordered table-striped">
									<thead>
										<tr>
											<th>
												<input
													type="checkbox"
													@change="toggleSelectAll"
													:checked="allSelected"
												/>
											</th>
											<th>#</th>
											<th class="text-center">Action</th>
											<th>Template Name</th>
											<th>Equipment</th>
											<th>Date Time</th>
											<th>Component Type</th>
											<th>Check Type</th>
											<th>Default</th>
											<th>Value</th>
											<th>Department</th>
											<th>User</th>
											<th>Note</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(item, key) in deviated_components"
											:key="item.user_equipment_component_id"
										>
											<td>
												<input
													type="checkbox"
													:value="item.user_equipment_component_id"
													v-model="selectedComponents"
												/>
											</td>
											<td>{{ deviated.from + key }}</td>
											<td class="text-center">
												<button
													data-bs-toggle="modal"
													data-bs-target="#remarkModal"
													@click="addRemark(item)"
													class="btn btn-xs btn-primary"
												>
													<i class="fa fa-add"></i>
												</button>
											</td>
											<td>{{ item.template_name }}</td>
											<td>{{ item.equipment }}</td>
											<td>{{ item.date_time }}</td>
											<td>{{ item.component_type?.component_type_name }}</td>
											<td>{{ item.check_type?.check_type_name }}</td>
											<td>{{ item.default_value }}</td>
											<td>{{ item.value }}</td>
											<td>{{ item.user_template?.department?.department_name }}</td>
											<td>{{ item.user_template?.user?.name }}</td>
											<td>{{ item.note }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div class="card-footer">
							<Pagination
								class="pagination pagination-sm"
								:maxPage="deviated.maxPage"
								:totalPages="deviated.lastPage"
								:currentPage="deviated.page"
								@pagechanged="onDeviatedPageChange"
							/>
						</div>
					</div>
				</div>
			</div>

			<!-- Modals -->
			<div class="modal fade" id="remarkModal" tabindex="-1">
				<div class="modal-dialog">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Update Remark</h5>
							<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
						</div>
						<div class="modal-body">
							<div class="field-wrapper">
								<div class="field-placeholder">Remark *</div>
								<textarea
									class="form-control"
									v-model="remark.remark"
									:class="{ 'is-invalid': errors.remark }"
									placeholder="Enter Remark"
								></textarea>
								<span v-if="errors.remark" class="invalid-feedback">{{
									errors.remark[0]
								}}</span>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
								Close
							</button>
							<button
								type="button"
								@click="updateRemark()"
								class="btn btn-primary"
								data-bs-dismiss="modal"
							>
								Update
							</button>
						</div>
					</div>
				</div>
			</div>

			<div class="modal fade" id="multiRemarkModal" tabindex="-1" ref="multiRemarkModal">
				<div class="modal-dialog">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Update Remarks</h5>
							<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
						</div>
						<div class="modal-body">
							<div class="field-wrapper">
								<div class="field-placeholder">Remark *</div>
								<textarea
									class="form-control"
									v-model="multiRemark"
									:class="{ 'is-invalid': errors.multiRemark }"
									placeholder="Enter Remarks"
								></textarea>
								<span v-if="errors.multiRemark" class="invalid-feedback">{{
									errors.multiRemark[0]
								}}</span>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
								Close
							</button>
							<button
								type="button"
								@click="updateMultipleRemarks"
								class="btn btn-primary"
							>
								Update
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";
import Pagination from "@/components/Pagination.vue";

export default {
	components: { Pagination },
	data() {
		return {
			meta: {
				user_id: this.$store.getters.user?.user_id,
				frequency_id: "",
				from_date: "",
				to_date: "",
				cluster_id: "",
				plant_id: "",
				department_id: "",
			},
			frequencies: [],
			frequency_name: "",
			ho_frequency_compliance: null,
			overallExpected: 0,
			overallSubmitted: 0,
			clusters: [],
			selectedCluster: null,
			showClusters: false,
			departments: [],
			plant_code: "",
			department_name: "",
			deviated_components: [],
			deviated: {
				page: 1,
				per_page: 10,
				totalRows: 0,
				lastPage: 1,
				from: 1,
				maxPage: 1,
			},
			selectedComponents: [],
			allSelected: false,
			multiRemark: "",
			remark: { user_equipment_component_id: "", remark: "" },
			errors: {},
		};
	},

	mounted() {
		this.getFrequencies();
	},

	watch: {
		selectedComponents(newVal) {
			this.allSelected =
				newVal.length === this.deviated_components.length && newVal.length > 0;
		},
	},

	methods: {
		formatDateTime(date) {
			return date ? moment(date).format("DD-MM-YYYY HH:mm") : "-";
		},

		toggleSelectAll() {
			if (this.allSelected) {
				this.selectedComponents = [];
			} else {
				this.selectedComponents = this.deviated_components.map(
					(d) => d.user_equipment_component_id
				);
			}
			this.allSelected = !this.allSelected;
		},

		openMultiRemarkModal() {
			this.multiRemark = "";
			this.errors = {};
		},

		updateMultipleRemarks() {
			let vm = this;
			vm.errors = {};

			if (!vm.multiRemark.trim()) {
				vm.errors.multiRemark = ["Remark is required."];
				return;
			}

			if (vm.selectedComponents.length === 0) {
				vm.$store.dispatch("error", "Please select at least one component.");
				return;
			}

			const selectedObjects = vm.deviated_components
				.filter((dc) => vm.selectedComponents.includes(dc.user_equipment_component_id))
				.map((dc) => ({ user_equipment_component_id: dc.user_equipment_component_id }));

			const payload = {
				deviated_components: selectedObjects,
				remark: vm.multiRemark.trim(),
				user_id: vm.$store.getters.user?.user_id,
			};

			const loader = vm.$loading.show();

			vm.$store
				.dispatch("post", {
					uri: "bulkupdateDeviatedRemarks",
					data: payload,
				})
				.then(() => {
					loader.hide();
					vm.selectedComponents = [];
					vm.multiRemark = "";
					vm.allSelected = false;
					vm.$store.dispatch("success", "Remarks updated successfully.");
					vm.getHoDeviatedComponents();

					const closeButton = document.querySelector('#multiRemarkModal .btn-secondary[data-bs-dismiss="modal"]');
					if (closeButton) closeButton.click();
				})
				.catch((error) => {
					loader.hide();
					vm.errors = error.response?.data?.errors || {};
					vm.$store.dispatch("error", error.response?.data?.message || "An error occurred");
				});
		},

		getFrequencies() {
			this.$store
				.dispatch("post", {
					uri: "getDashboardFrequencies",
					data: { user_id: this.meta.user_id },
				})
				.then((r) => {
					this.frequencies = r.data.data || [];
					if (this.frequencies.length) {
						this.meta.frequency_id = this.frequencies[0].frequency_id;
						this.updateFromDateToDate();
					}
				});
		},

		updateFromDateToDate() {
			const freq = this.frequencies.find((f) => f.frequency_id == this.meta.frequency_id);
			if (!freq) return;
			this.frequency_name = freq.frequency_name;

			if (freq.frequency_name.includes("Daily")) {
				const date = moment().subtract(1, "days").format("YYYY-MM-DD");
				this.meta.from_date = this.meta.to_date = date;
			} else if (freq.frequency_name.includes("Weekly")) {
				this.meta.from_date = moment().subtract(1, "weeks").startOf("isoWeek").format("YYYY-MM-DD");
				this.meta.to_date = moment().subtract(1, "weeks").endOf("isoWeek").format("YYYY-MM-DD");
			} else if (freq.frequency_name.includes("Monthly")) {
				this.meta.from_date = moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD");
				this.meta.to_date = moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD");
			}
			else if (freq.frequency_name.includes('Fortnightly')) {
				const today = moment();
				if (today.date() <= 15) {
					this.meta.from_date = today.subtract(1, 'month').date(16).format('YYYY-MM-DD');
					this.meta.to_date = today.endOf('month').format('YYYY-MM-DD');
				} else {
					this.meta.from_date = today.startOf('month').format('YYYY-MM-DD');
					this.meta.to_date = today.date(15).format('YYYY-MM-DD');
				}
			}

			this.resetData();
			this.getHoFrequencyCompliance();
		},

		resetData() {
			this.ho_frequency_compliance = null;
			this.clusters = [];
			this.selectedCluster = null;
			this.showClusters = false;
			this.departments = [];
			this.plant_code = "";
			this.department_name = "";
			this.deviated_components = [];
			this.selectedComponents = [];
			this.allSelected = false;
			this.deviated.page = 1;
			this.deviated.totalRows = 0;
		},

		getHoFrequencyCompliance() {
			this.resetData();
			const loader = this.$loading.show();
			this.$store
				.dispatch("post", {
					uri: "ho/clusters/compliance",
					data: {
						user_id: this.meta.user_id,
						frequency_id: this.meta.frequency_id,
						from_date: this.meta.from_date,
						to_date: this.meta.to_date,
					},
				})
				.then((r) => {
					loader.hide();
					this.ho_frequency_compliance = r.data.overall_compliance;
					this.overallExpected = r.data.overall_expected;
					this.overallSubmitted = r.data.overall_submitted;
					this.clusters = r.data.clusters || [];
				})
				.catch(() => loader.hide());
		},

		selectCluster(cluster) {
			this.selectedCluster = cluster;
			this.showClusters = true;
		},

		getHoDepartmentCompliance(plant_id, plant_code) {
			this.plant_code = plant_code;
			this.meta.plant_id = plant_id;
			this.departments = [];
			this.deviated_components = [];
			this.selectedComponents = [];
			this.allSelected = false;

			const loader = this.$loading.show();
			this.$store
				.dispatch("post", {
					uri: "ho/department/compliance",
					data: {
						user_id: this.meta.user_id,
						plant_id,
						frequency_id: this.meta.frequency_id,
						from_date: this.meta.from_date,
						to_date: this.meta.to_date,
					},
				})
				.then((r) => {
					loader.hide();
					this.departments = r.data.departments || [];
				})
				.catch(() => loader.hide());
		},

		selectDepartment(dept) {
			this.meta.department_id = dept.department_id;
			this.department_name = dept.department_name;
			this.getHoDeviatedComponents();
		},

		getHoDeviatedComponents() {
			const loader = this.$loading.show();
			this.$store
				.dispatch("post", {
					uri: "ho/deviated/components",
					data: { ...this.meta, page: this.deviated.page, per_page: this.deviated.per_page },
				})
				.then((r) => {
					loader.hide();
					this.deviated_components = (r.data.data || []).map((c) => ({
						...c,
						date_time: moment(c.date_time).format("DD-MM-YYYY HH:mm"),
					}));
					const m = r.data.meta || {};
					this.deviated.totalRows = m.total || 0;
					this.deviated.lastPage = m.last_page || 1;
					this.deviated.from = m.from || 1;
					this.deviated.maxPage = this.deviated.lastPage >= 3 ? 3 : this.deviated.lastPage;

					this.allSelected = this.deviated_components.length > 0 &&
						this.deviated_components.every(dc =>
							this.selectedComponents.includes(dc.user_equipment_component_id)
						);
				})
				.catch(() => loader.hide());
		},

		getColor(value) {
			if (value >= 80) return "green";
			else if (value >= 50) return "orange";
			else if (value === "NA") return "gray";
			else return "red";
		},

		addRemark(item) {
			this.remark = {
				user_equipment_component_id: item.user_equipment_component_id,
				remark: item.remark || "",
			};
		},

		updateRemark() {
			const payload = {
				user_equipment_component_id: this.remark.user_equipment_component_id,
				remark: this.remark.remark,
				user_id: this.meta.user_id,
			};

			const loader = this.$loading.show();
			this.$store
				.dispatch("post", { uri: "updateDeviatedRemarks", data: payload })
				.then(() => {
					loader.hide();
					this.$store.dispatch("success", "Remark updated successfully");
					this.getHoDeviatedComponents();
				})
				.catch((err) => {
					loader.hide();
					this.errors = err.response?.data?.errors || {};
				});
		},

		onDeviatedPageChange(p) {
			this.deviated.page = p;
			this.getHoDeviatedComponents();
		},
	},
};
</script>

<style scoped>
#label,
h6,
small {
	color: #fff !important;
}

.card .card-body {
	padding: 10px;
}

.card .card-footer {
	padding: 10px;
}

.table {
	margin-bottom: 0rem;
}

.btn-xs {
	padding: 1px;
	margin: 1px;
}

.dashboard-header-content {
	margin-left: -5px;
}

.sales-tile-container {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}

.sales-tile {
	cursor: pointer;
	margin: 8px;
	padding: 12px;
	border-radius: 12px;
	text-align: center;
	transition: all 0.3s;
	min-width: 140px;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.text-warning {
	color: #ffd700 !important;
}
</style>